import WithdrawalCommands from '@app/dev/terminal/components/withdrawal/commands';
import ToastWrapper from '@common/helpers/toastWrapper';

class WithdrawalService {
  static getBetShopList = async () => {
    const data = await WithdrawalCommands.getBetshopList();

    if (!data) return null;

    return data.result?.cities;
  }
  static getBalance = async () => {
    const data = await WithdrawalCommands.getClientBalance();

    if (!data) return null;

    return data.details;
  }

  static createCashRequest = async (amount, officeId) => {
    const data = await WithdrawalCommands.cashWithdrawalRequest(amount, officeId);

    if (data.result !== 0) {
      ToastWrapper("error", data.details);
      return null;
    } else {
      return data.details;
    }
  }

  static getHistory = async (start, end) => {
    const data = await WithdrawalCommands.getWithdrawalHistory(start, end);

    if (data.result !== 0) {
      ToastWrapper("error", data.details);
    }
    return data.details;
  }
}
export default WithdrawalService;
